// extracted by mini-css-extract-plugin
export var layout = "Services-module--layout--0711e";
export var title = "Services-module--title--aa4d2";
export var subtitle = "Services-module--subtitle--e7f07";
export var column = "Services-module--column--a167a";